export default __webpack_public_path__ + "static/media/aboutHero.b68c6701.jpg";